import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HomePendingApi } from './home-pending-change';

@Injectable({ providedIn: 'root' })
export class HomePendingChangeService {
  constructor(
    private http: HttpClient
  ) {
  }

  /**
   * Applies a pending Toxic Gas or Rad Area change to the Home page.
   * @param api Controller that owns the pending change.
   * @param pendingId Pending request identifier.
   */
  approve(api: HomePendingApi, pendingId: number): Observable<void> {
    return this.http.put<void>(this.url(api) + 'Approve/' + pendingId, null);
  }

  /**
   * Rejects a pending change; the Home page keeps its approved values.
   * @param api Controller that owns the pending change.
   * @param pendingId Pending request identifier.
   * @param reason Reason shown to the submitter.
   */
  disapprove(api: HomePendingApi, pendingId: number, reason: string): Observable<void> {
    return this.http.put<void>(this.url(api) + 'Disapprove/' + pendingId, { reason });
  }

  /**
   * Withdraws the current user's own pending change.
   * @param api Controller that owns the pending change.
   * @param pendingId Pending request identifier.
   */
  cancel(api: HomePendingApi, pendingId: number): Observable<void> {
    return this.http.delete<void>(this.url(api) + 'Pending/' + pendingId);
  }

  /**
   * Hides a disapproved change from the submitter's pending-changes list.
   * @param api Controller that owns the pending change.
   * @param pendingId Pending request identifier.
   */
  removeRow(api: HomePendingApi, pendingId: number): Observable<void> {
    return this.http.patch<void>(this.url(api) + 'RemoveRow/' + pendingId, null);
  }

  private url(api: HomePendingApi): string {
    return environment.urls.baseApiUrl + '/' + api + '/';
  }
}
